export const getSectionFullCode = (code, survey) => {
  if (!code || !survey?.year || !survey?.type || !survey?.subType) {
    return code;
  }

  const codeParts = code.split('#');
  if (codeParts.length === 4) {
    return code;
  }

  return `${code}#${survey.year}#${survey.type.toUpperCase()}#${survey.subType.toUpperCase()}`;
};

export const prepareSectionMetadata = (metadata, oldMetadata, survey) => {
  if (survey?.type && survey?.subType && survey?.year) {
    const overrideCode = `${
      survey.year
    }#${survey.type.toUpperCase()}#${survey.subType.toUpperCase()}`;
    const newSectionMetadata = {
      ...oldMetadata,
      overrides: {
        ...oldMetadata?.overrides,
        [overrideCode]: {
          ...oldMetadata?.overrides?.[overrideCode],
        },
      },
      name: metadata?.name,
      code: getSectionFullCode(metadata?.code, survey),
    };

    return newSectionMetadata;
  }

  return metadata;
};

export const getSectionNameByCodeAndSurvey = (code, survey, sections = []) => {
  if (!code) return '';

  const sectionIdentifier = String(code);

  const hasSurveyInfo = survey && survey.year && survey.type && survey.subType;

  // "2025#BUF#ASLP"
  const overrideCode = hasSurveyInfo
    ? `${survey.year}#${String(survey.type).toUpperCase()}#${String(survey.subType).toUpperCase()}`
    : null;

  // Build full section code: "001#2025#BUF#ASLP"
  const fullSectionCode = overrideCode ? `${sectionIdentifier}#${overrideCode}` : null;

  const findByCode = (candidateCode) =>
    sections.find(
      (s) =>
        s?.Data?.code && candidateCode && s.Data.code.toLowerCase() === candidateCode.toLowerCase()
    );

  // Sections saved since BEN-2344 carry the full composite code.
  const fullCodeSection = fullSectionCode ? findByCode(fullSectionCode) : null;
  if (fullCodeSection) {
    return fullCodeSection.Data.name || sectionIdentifier;
  }

  // Sections saved before BEN-2344 keep their per-survey name under Data.overrides,
  // and are only migrated to a composite code once they are re-saved.
  const overrideSection = overrideCode
    ? sections.find(
        (s) =>
          s?.Data?.overrides?.[overrideCode]?.code?.toLowerCase() ===
          sectionIdentifier.toLowerCase()
      )
    : null;
  if (overrideSection) {
    return overrideSection.Data.overrides[overrideCode].name || sectionIdentifier;
  }

  // Otherwise match the simple identifier (e.g. "001"), then fall back to it.
  const section = findByCode(sectionIdentifier);
  return section?.Data?.name || sectionIdentifier;
};
